import React from 'react'
import PropTypes from 'prop-types';
import {
  ButtonContainer
} from 'src/Common/Components/Styles/PrimaryButton.styles';

const PrimaryButton = (props) => {
  const Icon = props.icon;

  return (

    <ButtonContainer
      onClick={() => props.onClick}
      disabled={!props.isEnabled}
      backgroundColor={props.isEnabled ? props.activeBackgroundColor : props.inActiveBackgroundColor}
      {...props}>

      {!!Icon &&
        <div style={{marginRight:'8px', display: 'flex'}}>
        <Icon
          fontSize={props.iconSize}
          color={props.iconColor}
          strokeColor={props.iconStrokeColor}
          fill={props.iconFill}
          height={props.iconHeight}
          width={props.iconWidth} />
          </div>
      }
      {props.buttonText}

    </ButtonContainer>
  )
}

PrimaryButton.propTypes = {
  color: PropTypes.string,
  border: PropTypes.string,
  borderRadius: PropTypes.string,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  padding: PropTypes.string,
  buttonText: PropTypes.string,
  activeColor: PropTypes.string,
  inActiveColor: PropTypes.string,
  activeBackgroundColor: PropTypes.string,
  inActiveBackgroundColor: PropTypes.string,
  isEnabled: PropTypes.bool,
  flex: PropTypes.string,
  justifyContent: PropTypes.string,
  alignItems: PropTypes.string,
  alignSelf: PropTypes.string,
  icon: PropTypes.func,
  iconSize: PropTypes.string,
  iconColor: PropTypes.string,
  iconStrokeColor: PropTypes.string,
  iconHeight: PropTypes.string,
  iconFill: PropTypes.string,
  iconWidth: PropTypes.string,
  iconMargin: PropTypes.string,
  onClick: PropTypes.func,
  
};

PrimaryButton.defaultProps = {
  color: 'white',
  border: 'none',
  borderRadius: '16px',
  fontSize: '16px',
  fontWeight: '500',
  padding: '12px 28px',
  buttonText: 'Button',
  activeColor: 'white',
  inActiveColor: 'white',
  activeBackgroundColor: 'red',
  inActiveBackgroundColor: 'grey',
  isEnabled: true,
  showIcon: false,
  flex: 'none',
  justifyContent: 'center',
  alignItems: 'center',
  iconSize: '25px',
  iconColor: 'black',
  iconStrokeColor: '#282828',
  iconHeight: '19px',
  iconFill: 'black',
  iconWidth: '19px',
};

export default PrimaryButton